// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Show password',
    hide: 'Hide password',
    copy: 'Copy',
    copied: 'Copied',
    once: 'Shown only now. Copy it and keep it somewhere safe.',
  },
  loading: 'Loading the change…',
  load_failed: "I couldn't load this change.",
  load_retry: 'Try again',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'This change shows here once Amigo is back. Nothing has changed.',
    assistant: 'This change shows here once the assistant is back. Nothing has changed.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'This was already approved, so there was nothing more to do.',
  action_failed: "That didn't go through, so nothing changed. Try again in a moment.",
  removed: 'Removed',
  retry: 'Try again',
  retry_one: 'Try {{name}} again',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approved.',
    retried: 'Tried again.',
    rejected: 'Rejected.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Skipped on the card.',
  },
  done: {
    summary_one: 'Done. {{count}} change applied.',
    summary_other: 'Done. {{count}} changes applied.',
    skipped_one: '{{count}} skipped, nothing changed for it.',
    skipped_other: '{{count}} skipped, nothing changed for them.',
  },
  partial: {
    summary_one: "{{applied}} of {{approved}} changes applied. {{count}} didn't.",
    summary_other: "{{applied}} of {{approved}} changes applied. {{count}} didn't.",
    detail_one: 'The {{applied}} are saved. Nothing changed for the {{count}} below.',
    detail_other: 'The {{applied}} are saved. Nothing changed for the {{count}} below.',
  },
  stale: {
    summary: '{{applied}} of {{approved}} changes applied.',
    detail_one: '{{count}} was changed by someone else in the meantime.',
    detail_other: '{{count}} were changed by someone else in the meantime.',
    reason:
      '{{name}} changed it to {{value}} at {{time}}, before you approved, so I left it. Here it is again from the new value:',
    decided_done:
      '{{name}} changed it to {{value}} at {{time}}, before you approved, so I left it. Its new proposal was approved on its own card.',
    decided_rejected:
      '{{name}} changed it to {{value}} at {{time}}, before you approved, so I left it. Its new proposal was rejected.',
    decided_replaced:
      '{{name}} changed it to {{value}} at {{time}}, before you approved, so I left it. Its new proposal was replaced by a newer card.',
    decided_expired:
      '{{name}} changed it to {{value}} at {{time}}, before you approved, so I left it. Its new proposal expired.',
  },
  undo_partly_one: "{{count}} of these can't be undone.",
  undo_partly_other: "{{count}} of these can't be undone.",
  undone: {
    summary_one: 'Undone. The {{count}} change is back to before.',
    summary_other: 'Undone. The {{count}} changes are back to before.',
    detail: 'The undo is recorded in the Amigo log and in Menu → Edit history too.',
    partly_summary: 'Partly undone. {{undone}} of {{count}} changes are back to before.',
    partly_changed_one: '{{count}} was changed by someone else since, so it stays as it is.',
    partly_changed_other: '{{count}} were changed by someone else since, so they stay as they are.',
    partly_kept_one: '{{count}} was already back to before.',
    partly_kept_other: '{{count}} were already back to before.',
    partly_cannot_one: "{{count}} can't be undone, like a deletion, so it stays as it is.",
    partly_cannot_other: "{{count}} can't be undone, like a deletion, so they stay as they are.",
    partly_left_one: '{{count}} stays as it is.',
    partly_left_other: '{{count}} stay as they are.',
  },
  summary: {
    group_one: '{{count}} dish: {{reason}}',
    group_other: '{{count}} dishes: {{reason}}',
    group_names_more_one: '{{names}} and {{count}} more',
    group_names_more_other: '{{names}} and {{count}} more',
    average: '{{amount}} a dish on average',
    needs_look: 'Needs a look',
    nothing_else: 'Nothing else changes',
  },
  labels: {
    waiting: 'Pending',
    skip: 'Skip',
    unskip: 'Undo skip',
    approve_all: 'Approve all',
    approve_one: 'Approve {{count}}',
    approve_other: 'Approve {{count}}',
    approve_all_count_one: 'Approve all {{count}}',
    approve_all_count_other: 'Approve all {{count}}',
    approve_row: 'Approve',
    reject: 'Discard',
    reject_confirm: 'Reject',
    back: 'Back',
    why: {
      amigo: 'Why not? (optional, Amigo reads this)',
      assistant: 'Why not? (optional, the assistant reads this)',
    },
    hint: 'Or reply below to change something.',
    show_all_one: 'Show all {{count}} changes',
    show_all_other: 'Show all {{count}} changes',
    show_less: 'Show fewer',
    applying_one: 'Applying {{count}} change…',
    applying_other: 'Applying {{count}} changes…',
    high_impact: 'High impact',
    done: 'Done',
    running: 'Running',
    show_changes: 'Show changes',
    hide_changes: 'Hide changes',
    rows: {
      skipped: 'Skipped',
      applied: 'Applied',
      failed: 'Not applied',
      changed: 'Changed in the meantime',
      kept: 'Left as it is',
    },
    history: {
      amigo: 'Open in the Amigo log',
      assistant: "Open in the assistant's log",
    },
    undo: 'Undo',
    to: 'to',
    from: 'from',
    rejected: 'Rejected',
    replaced: 'Replaced',
    expired: 'Expired',
  },
};
